import {useEffect, useState} from "react";
import {SubmitButton} from "components/Button";
import {ModalContainer} from "./ModalContainer";

const FormInitialValues = {
	title: "Mr",
	firstName: "",
	lastName: "",
	nickname: "",
	username: "",
	phoneNumber: "",
	nik: "",
	password: "",
	gender: "male",
	maritalStatus: "married",
};

export function ModalAddRelationPatient({visible, onClose, onSubmit, loading = false, titleOptions = []}) {
	const [values, setValues] = useState(FormInitialValues);
	const [error, setError] = useState("");

	useEffect(() => {
		if (!visible) {
			setValues(FormInitialValues);
			setError("");
		}
	}, [visible]);

	const handleChange = (field, value) => {
		setValues(prev => ({...prev, [field]: value}));
	};

	const validate = () => {
		if (!values.title) return "Title wajib di isi";
		if (!values.firstName) return "Nama depan wajib di isi";
		if (!values.lastName) return "Nama belakang wajib di isi";
		if (!values.nickname) return "Nama panggilan wajib di isi";
		if (!values.username) return "Username wajib di isi";
		if (!/^[.a-z0-9_-]+$/.test(values.username))
			return "Username tidak valid. Hanya huruf kecil, angka, -, _, dan .";
		if (!values.password) return "Password wajib di isi";
		if (!values.nik || values.nik.length !== 16) return "ID number/KTP harus 16 digit";
		if (!values.phoneNumber) return "Nomor telepon wajib di isi";
		if (values.phoneNumber.length < 9 || values.phoneNumber.length > 15)
			return "Nomor telepon minimal 9 dan maksimal 15 digit";
		if (!values.maritalStatus) return "Status wajib di isi";

		return "";
	};

	const handleSubmit = () => {
		const validationError = validate();
		if (validationError) {
			setError(validationError);
			return;
		}

		setError("");
		onSubmit(values);
	};

	return (
		<ModalContainer visible={visible}>
			<div className="box-popup w650">
				<div className="d-flex justify-content-between align-items-center mb-4">
					<div className="text-bold text-dark">Tambah Pasangan Baru</div>
					<div className="for-close">
						<button className="btn btn-close" disabled={loading} type="button" onClick={onClose} />
					</div>
				</div>
				<div className="popup-content scroll">
					<div className="row gx-2">
						<div className="col-sm-6">
							<label className="setting-label required">Title</label>
							<select
								className="form-control"
								value={values.title}
								onChange={e => handleChange("title", e.target.value)}>
								{(titleOptions.length ? titleOptions : [{value: "Mr", label: "Mr"}]).map(item => (
									<option key={item.value} value={item.value}>
										{item.label}
									</option>
								))}
							</select>
						</div>
						<div className="col-sm-6">
							<label className="setting-label required">Gender</label>
							<select
								className="form-control"
								value={values.gender}
								onChange={e => handleChange("gender", e.target.value)}>
								<option value="male">Male</option>
								<option value="female">Female</option>
							</select>
						</div>
						<div className="col-sm-6 mt-3">
							<label className="setting-label required">Nama Depan</label>
							<input
								className="form-control"
								type="text"
								value={values.firstName}
								onChange={e => handleChange("firstName", e.target.value)}
							/>
						</div>
						<div className="col-sm-6 mt-3">
							<label className="setting-label required">Nama Belakang</label>
							<input
								className="form-control"
								type="text"
								value={values.lastName}
								onChange={e => handleChange("lastName", e.target.value)}
							/>
						</div>
						<div className="col-sm-6 mt-3">
							<label className="setting-label required">Nama Panggilan</label>
							<input
								className="form-control"
								type="text"
								value={values.nickname}
								onChange={e => handleChange("nickname", e.target.value)}
							/>
						</div>
						<div className="col-sm-6 mt-3">
							<label className="setting-label required">Username</label>
							<input
								className="form-control"
								type="text"
								value={values.username}
								onChange={e => handleChange("username", e.target.value.toLowerCase())}
							/>
						</div>
						<div className="col-sm-6 mt-3">
							<label className="setting-label required">Nomor Telepon</label>
							<input
								className="form-control"
								type="text"
								value={values.phoneNumber}
								onChange={e => handleChange("phoneNumber", e.target.value.replace(/\D/g, ""))}
							/>
						</div>
						<div className="col-sm-6 mt-3">
							<label className="setting-label required">ID Number/KTP</label>
							<input
								className="form-control"
								maxLength={16}
								type="text"
								value={values.nik}
								onChange={e => handleChange("nik", e.target.value.replace(/\D/g, ""))}
							/>
						</div>
						<div className="col-sm-6 mt-3">
							<label className="setting-label required">Password</label>
							<input
								className="form-control"
								type="password"
								value={values.password}
								onChange={e => handleChange("password", e.target.value)}
							/>
						</div>
						<div className="col-sm-6 mt-3">
							<label className="setting-label required">Marital Status</label>
							<select
								className="form-control"
								value={values.maritalStatus}
								onChange={e => handleChange("maritalStatus", e.target.value)}>
								<option value="single">Single</option>
								<option value="married">Married</option>
							</select>
						</div>
					</div>
					{error ? <p className="form-error-item-message mt-3 mb-0">{error}</p> : null}
					<div className="d-flex justify-content-around mt-4">
						<button className="btn btn-red r8 w-45" disabled={loading} type="button" onClick={onClose}>
							Batal
						</button>
						<SubmitButton
							className="btn btn-green r8 w-45"
							loading={loading}
							text="Simpan Pasangan"
							type="button"
							onClick={handleSubmit}
						/>
					</div>
				</div>
			</div>
		</ModalContainer>
	);
}
